import { z } from "zod"
import { baseSchema, schemaToJson } from "../schema-utils.js"

const DbSubscriptionSchema = z.strictObject({
  ...baseSchema.shape,
  publisher_id: z.string(),
  created_at: z.date().nullable(),
  silenced: z.boolean(),
})
export type DbSubscription = z.infer<typeof DbSubscriptionSchema>

export const SubscriptionSchema = schemaToJson(DbSubscriptionSchema)
export type Subscription = z.infer<typeof SubscriptionSchema>
